"use strict";
const buttons = document.querySelectorAll('.button');
buttons.forEach((button) => {
    const defaultText = button.querySelector('.text--default');
    const hoverText = button.querySelector('.text--hover');
    if (!defaultText || !hoverText)
        return;
    // 状態管理フラグ
    let isAnimating = false;
    const tl = gsap.timeline({ paused: true });
    tl.to(defaultText, {
        y: '-100%',
        rotateX: 70,
        duration: 0.4,
        ease: 'power2.out',
    }, 0).to(hoverText, {
        y: '-100%',
        rotateX: 0,
        duration: 0.4,
        ease: 'power2.out',
    }, 0);
    button.addEventListener('mouseenter', () => {
        // アニメーション中は実行しない（連続実行を防止）
        if (isAnimating)
            return;
        isAnimating = true;
        gsap.set([defaultText, hoverText], { opacity: 1 });
        tl.restart(); // play()ではなくrestart()を使用
        // アニメーション完了後にフラグをリセット
        setTimeout(() => {
            isAnimating = false;
        }, 400); // duration: 0.4秒と同じ
    });
    button.addEventListener('mouseleave', () => {
        // hover outしても何もしない（テキストは表示されたままを保持）
    });
});
//# sourceMappingURL=ljsw-button.js.map